import { faCircleMinus } from "@fortawesome/sharp-solid-svg-icons"
import { Box } from "@mui/material"
import type { GridColDef } from "@mui/x-data-grid-pro"
import { extraColors } from "../../../utils/theme"
import type { BiothreatSignal } from "../AlertCurationContext"
import {
  ActionCell,
  getSharedAlertCandidateColumns,
} from "./SharedAlertTableColumns"

interface GetPotentialAlertColumnsParams {
  removeFromPotential: (id: string) => void
}

export const getPotentialAlertColumns = ({
  removeFromPotential,
}: GetPotentialAlertColumnsParams) => {
  const actionColumn = {
    field: "action",
    headerName: "",
    width: 20,
    sortable: false,
    align: "left",
    headerAlign: "left",
    renderCell: cellParams => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ActionCell
          actions={[
            {
              onAction: (row: BiothreatSignal) => removeFromPotential(row.id),
              icon: faCircleMinus,
              tooltip: "Remove from Selected Signals",
              color: extraColors.status.redLight,
            },
          ]}
          row={cellParams.row}
        />
      </Box>
    ),
  } satisfies GridColDef<BiothreatSignal>

  const sharedColumns = getSharedAlertCandidateColumns().filter(
    c => !["cluster_id", "archive"].includes(c.field)
  )

  return [actionColumn, ...sharedColumns]
}
